import { useQuery } from '@tanstack/react-query';
import { DateFormatter } from 'infrastructure/functions';
import dataService from 'services/dataService';
import { apiCcmPatientInteractiveTime } from 'services/dataService/ccmResources';
import { showResult } from 'infrastructure/hooks/utils';

interface Props {
  patientGuid: string;
  enabled: boolean;
}

interface Res {
  patientGuid: string;
  clinicGuid: string;
  totalTime: number;
  clinicTime: number;
}

export const getCcmInteractionTimeKey = (patientGuid: string, date: string) => [
  'getCcmInteractionTime',
  patientGuid,
  date,
];

export const useGetCcmInteractionTime = ({ patientGuid, enabled }: Props) => {
  const today = new Date();
  const formattedDate = DateFormatter({ date: today });

  const { data: ccmInteractionTime, ...other } = useQuery({
    queryKey: getCcmInteractionTimeKey(patientGuid, formattedDate),
    queryFn: async () => {
      const { data, error } = await dataService.getList<Res>(
        apiCcmPatientInteractiveTime(patientGuid, formattedDate),
      );

      if (error) {
        showResult(error);
        throw new Error(error);
      }

      return data;
    },
    enabled,
  });

  return { ccmInteractionTime, ...other };
};
